import { ELocale } from './i18n/localeEnum';

export const ENV = process.env.NEXT_PUBLIC_ENV;
export const MEMCACHE_PORT = process.env.NEXT_PUBLIC_MEMCACHE_PORT;
export const BUILD_LOCALE = process.env.NEXT_PUBLIC_LANG;
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const INTERNAL_API_URL = process.env.NEXT_PUBLIC_INTERNAL_API_URL;
export const IS_SUMMER = process.env.NEXT_PUBLIC_IS_SUMMER;
export const BUILD_DATE = process.env.BUILD_TIME;
export const IS_SSR = typeof window === 'undefined';
export const IS_NODE_ENV_DEVELOP = process.env.NODE_ENV !== 'production';
export const isProductionServer = ENV === 'production';

export const PRERENDER_DYNAMIC: boolean = process.env.PRERENDER_DYNAMIC === '1' || process.env.PRERENDER_DYNAMIC === 'true';
export const WEATHER_PAGE_SIZE = 50;
export const DEFAULT_REVALIDATE = 5 * 60; // 5 minutes

export const USE_LINKS_PREFETCH: boolean | undefined = undefined;

export const AB_VARIATION_NAME = process.env.NEXT_PUBLIC_AB_VARIATION_NAME || '';

export const RESORT_IDS_TO_HIDE_LODGING_FOR = ['1717'];
export const WESKI_FLEXIBLE_OPTION = 'flexible';

// https://mountainnews.jira.com/browse/OWR-2047
export const RESORTS_WITHOUT_WE_SKI = [
  { locale: ELocale.FR_FR, resortId: '592' },
  { resortId: '579' },
  { resortId: '550' },
  { resortId: '518' },
  { resortId: '2765' },
  { resortId: '686' },
  { resortId: '668' },
  { resortId: '690' },
  { resortId: '2204' },
  { resortId: '2667' },
  { resortId: '715' },
  { resortId: '733' },
  { resortId: '606' },
  { resortId: '613' },
  { resortId: '1248' },
  { resortId: '651' },
  { resortId: '1250' },
  { resortId: '658' },
  { resortId: '612' },
  { resortId: '638' },
  { resortId: '2335' },
  { resortId: '2054' },
  { resortId: '2471' },
  { resortId: '2330' },
  { resortId: '2051' },
  { resortId: '1972' },
  { resortId: '2043' },
  { resortId: '2195' },
  { resortId: '1741' },
  { resortId: '1949' },
  { resortId: '3030' },
  { resortId: '2609' },
  { resortId: '2282' },
  { resortId: '1766' },
  { resortId: '2250' },
  { resortId: '1931' },
  { resortId: '2098' },
  { resortId: '2739' },
  { resortId: '2549' },
  { resortId: '3565' },
  { resortId: '1692' },
  { resortId: '3033' },
  { resortId: '2207' },
  { resortId: '2452' },
  { resortId: '2139' },
  { resortId: '2481' },
  { resortId: '2387' },
  { resortId: '1919' },
];

// https://mountainnews.jira.com/browse/OWR-2047
export const REGIONS_WITHOUT_WE_SKI = [
  { locale: ELocale.FR_FR, regionId: '15' },
];

// https://mountainnews.jira.com/browse/OWR-2012
export const RESORTS_WITH_SUMMER_GUIDE_PAGE = [
  { locale: ELocale.EN_US, resortId: '191' },
  { locale: ELocale.FR_FR, resortId: '592' },
  { locale: ELocale.DE_DE, resortId: '727' },
  { locale: ELocale.IT_IT, resortId: '1883' },
];
